/**
 * Motion tokens. Pure value (no React/RN imports).
 *
 * Easings are cubic-bézier control points (not Easing.* calls) so the module
 * stays serialisable. Consumers apply them at the call site, e.g.
 *   Easing.bezier(...MOTION.easing.standard)
 *   withSpring(value, MOTION.spring.default)
 */
export const MOTION = {
  duration: {
    instant: 0,
    fast: 150,
    base: 250,
    slow: 400,
  },
  easing: {
    standard: [0.2, 0, 0, 1],
    decelerate: [0, 0, 0, 1],
    accelerate: [0.3, 0, 1, 1],
    emphasized: [0.05, 0.7, 0.1, 1],
  },
  spring: {
    default: { damping: 18, stiffness: 180, mass: 1 },
    gentle: { damping: 20, stiffness: 120, mass: 1 },
    bouncy: { damping: 12, stiffness: 180, mass: 1 },
  },
} as const;
